import React from "react";
import {Text, SimpleGrid, Stack, Button, Box, Link} from "@chakra-ui/core";

import Heading from "~/ui/display/Heading";
import Content from "~/ui/structure/Content";
import {useTranslation} from "~/i18n/hooks";

const FAQS = (t) => [
  {
    id: "free",
    title: t("plans.faqs.questions.one.question"),
    description: t("plans.faqs.questions.one.answer"),
  },
  {
    id: "close",
    title: t("plans.faqs.questions.two.question"),
    description: t("plans.faqs.questions.two.answer"),
  },
  {
    id: "creation",
    title: t("plans.faqs.questions.three.question"),
    description: t("plans.faqs.questions.three.answer"),
  },
  {
    id: "plans",
    title: t("plans.faqs.questions.four.question"),
    description: t("plans.faqs.questions.four.answer"),
  },
  {
    id: "metrics",
    title: t("plans.faqs.questions.five.question"),
    description: t("plans.faqs.questions.five.answer"),
  },
  {
    id: "support",
    title: t("plans.faqs.questions.sixth.question"),
    description: t("plans.faqs.questions.sixth.answer"),
  },
];

const FAQs: React.FC = () => {
  const t = useTranslation();

  return (
    <Content backgroundColor="white" paddingX={6} paddingY={{base: 12, md: 20}}>
      <Stack spacing={{base: 10, md: 16}}>
        <SimpleGrid
          alignItems="flex-end"
          columns={{base: 1, md: 2}}
          gridColumnGap={4}
          gridRowGap={4}
          justifyContent="space-between"
        >
          <Heading as="h2" fontSize={{base: "3xl", md: "4xl"}} maxWidth={480}>
            {t("plans.faqs.title")}
          </Heading>
          <Box textAlign={"center"}>
          <Link isExternal href={`${process.env.LINKS_URL}/${t("menu.help.url")}`}>
            <Button _focus={{border: "0px"}} rightIcon={"chevron-right"} variant="unstyled" color="primary.500">{t("plans.faqs.moreQuestions")}</Button>
          </Link>
          </Box>
        </SimpleGrid>
        <SimpleGrid columns={{base: 1, md: 3}} gridGap={12} my={8}>
          {FAQS(t).map((faq, index) => (
            <Stack spacing={3} key={index}>
              <Text fontSize="lg" fontWeight="bold">
                {faq.title}
              </Text>
              <Text>{faq.description}</Text>
            </Stack>
          ))}
        </SimpleGrid>
      </Stack>
    </Content>
  );
};

export default FAQs;
